import { useState, useEffect } from "react";
import style from "./Style.module.css";
import Util from "../../Util";

const Index = (props) => {
  const [review, setReview] = useState(props.review);

  useEffect(() => {
    setReview(props.review);
  }, [props.review]);

  const submitReview = async () => {
    const id = review.reviewID;
    const data = await Util.sendPost("/api/user/addMyScore", {
      sheet: id,
      score: review.review.score,
      message: review.review.message,
    });

    if (!data.success) {
      alert(data.msg);
    } else {
      alert("Comment ถูกเพิ่ม/แก้ไขสำเร็จ");
      setReview({
        reviewID: "",
        reviewName: "",
        review: { before: false, message: "", score: 0 },
      });
      props.onClose();
    }
  };

  const deleteReview = async () => {
    const id = review.reviewID;
    const data = await Util.sendPost("/api/user/deleteMyScore", { sheet: id });
    if (!data.success) alert(data.msg);
    else {
      alert("Comment ถูกลบสำเร็จ");
      setReview({
        reviewID: "",
        reviewName: "",
        review: { before: false, message: "", score: 0 },
      });
      props.onClose();
    }
  };

  const setRev = (field, value) => {
    let reportTemp = review.review;
    reportTemp[field] = value;
    setReview((prev) => {
      return { ...prev, review: reportTemp };
    });
  };

  if (props?.showReview === false) return null;

  return (
    <div className={review?.before ? style.reviewBox : style.reviewBoxShort}>
      <div className={style.rClose} onClick={props?.onClose}>
        X
      </div>
      <div className={style.rHeader}>Comment</div>
      <div className={style.rsn}>ชีท: {review?.reviewName}</div>
      <hr />
      <div className={style.rLabel}>ข้อความติชม (ไม่เกิน 100 ตัวอักษร)</div>
      <textarea
        onChange={(event) => setRev("message", event.currentTarget.value)}
        className={style.tArea}
        value={review?.review?.message}
      />
      {review?.review?.before ? (
        <div className={style.bGroup}>
          <div className={style.rAdd} onClick={submitReview}>
            บันทึก
          </div>
          <div className={style.rErase} onClick={deleteReview}>
            ลบ Comment
          </div>
        </div>
      ) : (
        <div className={style.bGroup}>
          <div className={style.rAdd} onClick={submitReview}>
            เพิ่ม Comment
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
